document.addEventListener("DOMContentLoaded", () => {
  const blocks = document.querySelectorAll(".bos_about-text-image-wrapper");

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        const mask = entry.target.querySelector(
          ".bos_about-text-image-mask",
        );
        const title = entry.target.querySelector(
          ".bos_about-text-image-title",
        );
        const textContent = entry.target.querySelector(
          ".bos_about-text-image-description",
        );
        const index = Array.from(blocks).indexOf(entry.target);

        if (entry.isIntersecting) {
          
          if (mask) {
            mask.style.transitionDelay = `${0.2 + index * 0.3}s`;
          }

          if (title) title.style.transitionDelay = `${0.8 + index * 0.3}s`;

          if (textContent)
            textContent.style.transitionDelay = `${1.2 + index * 0.15}s`;

          entry.target.classList.add("isVisible");
        } else {
          entry.target.classList.remove("isVisible");
        }
      });
    },
    { threshold: 0.2 },
  );

  blocks.forEach((block) => observer.observe(block));
});